// Navbar.jsx
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "./Navbar.css";
import beFitFriendsLogo from "../assets/befitfriendslogo.png";

export default function Navbar({ onJoin }) {
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();
  const onContactPage = pathname === "/contact";

  const homeHref = onContactPage ? "/#hero" : "#hero";
  const aboutHref = onContactPage ? "/#about" : "#about";
  const teamHref = onContactPage ? "/#team" : "#team";
  const brandHref = onContactPage ? "/#top" : "#top";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleJoinClick = (e) => {
    e.preventDefault(); // stop the #join jump
    if (onJoin) onJoin(); // open modal from App
  };

  return (
    <header className={`nav ${scrolled ? "nav-scrolled" : ""}`}>
      <div className="nav-inner container">
        <a
          href={brandHref}
          className="brand"
        >
          <img src={beFitFriendsLogo} alt="BeFitFriends" />
        </a>
        <nav className="nav-links">
          <a href={homeHref}>Home</a>
          <a href={aboutHref}>About</a>
          <a href={teamHref}>Team</a>
          <a href="/contact" className="nav-contact-link">Contact</a>
          {/*
          <a
            href="#join"
            className="btn btn-primary"
            onClick={handleJoinClick}
          >
            Join
          </a>
          */}
        </nav>
      </div>
    </header>
  );
}
